// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3I2l8","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2yztW"};